import type { Location } from '@/types/api'
import { createCrudService } from '../crud'

export type LocationInput = Pick<
  Location,
  'code' | 'country_id' | 'type_code' | 'name_en' | 'name_ru' | 'name_uz' | 'name_cyr' | 'status'
>

export const locationsService = createCrudService<Location, LocationInput>('locations')
